import React from "react";

import {
  RemoveCircle as RemoveCircleIcon,
  Edit as EditIcon,
  Info as InfoIcon,
  MoreHoriz as MoreHorizIcon,
} from "@mui/icons-material";
import { Box, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

const useStyles = makeStyles()({
  icon: {
    color: colors.grey,
    marginRight: 8,
    width: 20,
    height: 20,
  },
  text: {
    fontWeight: 600,
    color: "#949BA8",
  },
  red: {
    color: "#FF6262",
  },
  menuItem: {
    marginTop: 4,
  },
});

type OptionMenuProps = {
  onClickMenu: (type: string) => void;
  isAppointmentActive?: boolean;
};

const OptionMenu: React.FC<OptionMenuProps> = ({
  onClickMenu,
  isAppointmentActive = true,
}) => {
  const { classes } = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  function handleOnclick(type: string) {
    onClickMenu(type);
    handleClose();
  }

  return (
    <Box display="flex" flexDirection="row">
      <IconButton onClick={handleOpen} size="large">
        <MoreHorizIcon htmlColor="#26C9A7" />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => handleOnclick("details")}>
          <InfoIcon className={classes.icon} />
          <Typography
            className={classes.text}
            variant="body2"
            color="textPrimary"
          >
            Appointment Details
          </Typography>
        </MenuItem>
        {isAppointmentActive
          ? [
              <MenuItem
                key="option-menu-edit-item"
                className={classes.menuItem}
                onClick={() => handleOnclick("edit")}
              >
                <EditIcon className={classes.icon} />
                <Typography
                  className={classes.text}
                  variant="body2"
                  color="textPrimary"
                >
                  Edit Appointment
                </Typography>
              </MenuItem>,
              <MenuItem
                key="option-menu-cancel-item"
                className={classes.menuItem}
                onClick={() => handleOnclick("cancel")}
              >
                <RemoveCircleIcon
                  className={classes.icon}
                  style={{ color: "#FF6262" }}
                />
                <Typography
                  className={classes.text}
                  variant="body2"
                  style={{ color: "#FF6262" }}
                >
                  Cancel Appointment
                </Typography>
              </MenuItem>,
            ]
          : []}
      </Menu>
    </Box>
  );
};

export default OptionMenu;
